import React, { Component } from 'react';
import { NavItem } from '../../atoms';
// @ts-ignore
import logo from '../../../assets/svg/taggis-hub-logo.svg';
import classNames from 'classnames';
/** @typedef {import('../../molecules/NavItemGroup/NavItemGroup').NavItemObj} NavItemObj */

import './styles.css';

const MQ_SMALL_SCREEN = '(max-width: 1076px)';

/**
 * A header with a logo and navigation items.
 *
 * @typedef {Object} Props
 * @prop {Array<NavItemObj>} navItems
 * @prop {string} [className]
 *
 * @augments {Component<Props>}
 */
export default class HubHeader extends Component {

	state = {
		isSmallScreen: window.matchMedia(MQ_SMALL_SCREEN).matches,
	};

	componentDidMount () {
		this.mql = window.matchMedia(MQ_SMALL_SCREEN);
		this.mql.addListener(this.handleMediaChange);
	}

	handleMediaChange = ({ matches }) =>
		this.setState(() => ({
			isSmallScreen: !!matches,
		}));

	genClassName = (props) =>
		classNames('HubHeader', props.className);

	render () {
		const { navItems = [] } = this.props;
		const { isSmallScreen } = this.state;

		return (
			<header
				className={this.genClassName(this.props)}
			>
				<div className='Hub-header-wrapper'>
					{!isSmallScreen ? <img src={logo} alt={'Logo'} /> : null}
					<nav className='HubHeader-navItemGroup'>
						<ul >
							{navItems.map(
								(item) => <NavItem key={item.href} href={item.href}>{item.children}</NavItem>)
							}
						</ul>
					</nav>
				</div>
			</header>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/organisms/HubHeader/HubHeader.js